/**
 * 会展库相关请求接口
 */
import { pbrAxios } from '../../common/js/pbrAxios'

/** 会展列表检索 / 导出 */
const fetchExhibitionList = (body, query = {}) =>
  pbrAxios.post('/front/exhibition/search', body, { params: query })

/** 保存会展检索历史 */
const saveExhibitionSearchHistory = params =>
  pbrAxios.post('/front/exhibition/saveExhibitionSearchHistory', params)

/** 会展统计数据 */
const fetchExhibitionStatistic = params =>
  pbrAxios.post('/front/exhibition/statistic', params)

/** 会展热词 */
const fetchExhibitionHotWord = params =>
  pbrAxios.post('/front/exhibition/ghotword', params)

/** 获取会展搜索历史 */
const fetchExhibitionSearchHistory = params =>
  pbrAxios.post('/front/exhibition/ghconditions', params)

/** 置顶/取消置顶会展搜索历史 */
const pinExhibitionSearchHistory = params =>
  pbrAxios.post('/front/exhibition/upconditions', params)

/** 删除单条会展搜索历史 */
const deleteExhibitionSearchHistory = params =>
  pbrAxios.post('/front/exhibition/dhconditions', params)

/** 删除全部会展搜索历史 */
const deleteAllExhibitionSearchHistory = params =>
  pbrAxios.post('/front/searchHistory/delAllHistory', params)

/** 会展详情 */
const fetchExhibitionDetail = params =>
  pbrAxios.post('/front/exhibition/detail', params)

/** 会展相关风险 */
const fetchExhibitionRiskInfos = params =>
  pbrAxios.post('/front/exhibition/rinfos', params)

const exportExhibitionListUrl = '/front/exhibition/exportExhibitionExcel'

export default {
  fetchExhibitionList,
  saveExhibitionSearchHistory,
  fetchExhibitionStatistic,
  fetchExhibitionHotWord,
  fetchExhibitionSearchHistory,
  pinExhibitionSearchHistory,
  deleteExhibitionSearchHistory,
  deleteAllExhibitionSearchHistory,
  fetchExhibitionDetail,
  fetchExhibitionRiskInfos,
  exportExhibitionListUrl
}
